var map = {
	"./FailureTurtle1.gif": "4dcc",
	"./FailureTurtle2.gif": "5c8f",
	"./FailureTurtle3.gif": "afb0",
	"./SuccessTurtle1.gif": "24af",
	"./SuccessTurtle2.gif": "860b",
	"./SuccessTurtle3.gif": "55cd",
	"./games/navigator/portal_1.gif": "53ab",
	"./games/navigator/portal_2.gif": "8235"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc6d";